module.exports = __webpack_public_path__ + "img/9272c804ae2da81f7267cfbb5cabbd77.png";